import React, { ReactElement } from "react";
import { ToelichtingFiscaleAftrekHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";

import { FiscaleAftrekTable } from "./fiscale-aftrek-tabel";
import { GebeurtenissenTabel } from "./gebeurtenissen-tabel";
import { RenteAftrekTabel } from "./ontwikkeling-rente-aftrek-tabel";

export const ToelichtingAdviesFiscaleAftrekChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingFiscaleAftrekHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text={hoofdstuk.titel ?? "Fiscale aftrek"} level={3} />
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk?.advies}
          keuze={hoofdstuk?.keuze}
        />

        {hoofdstuk.fiscaleAftrekData && (
          <FiscaleAftrekTable data={hoofdstuk.fiscaleAftrekData} />
        )}
        {hoofdstuk?.gebeurtenissenTabelData && (
          <GebeurtenissenTabel data={hoofdstuk.gebeurtenissenTabelData} />
        )}
        {hoofdstuk?.renteaftrekkenTabelData?.rijen &&
          hoofdstuk.renteaftrekkenTabelData.rijen.length > 0 && (
            <div className="break-avoid">
              <Heading
                text={hoofdstuk.renteaftrekkenTabelData.titel}
                level={4}
                ignoreNumbers
              />
              <RenteAftrekTabel
                data={hoofdstuk.renteaftrekkenTabelData.rijen}
              />
            </div>
          )}
      </div>
    </Chapter>
  );
};
